import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pnel-sessions',
  templateUrl: './pnel-sessions.component.html',
  styleUrls: ['./pnel-sessions.component.scss']
})
export class PnelSessionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
